import React, { useEffect, useState } from 'react';

import { Web } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import menuOptions from './utils/menuOptions';
import { fetchTimeOffRequests } from './operations';
import TOR_STATUSES from './utils/TOR_STATUSES';
import { SubHeader, Footer } from '../../components';
import './styles.scoped.css';

const TimeOffRequests = () => {
  const navigate = useNavigate();
  const [pendingApprovalStatus, setPendingApprovalStatus] = useState(false);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadData(true);
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const response = await fetchTimeOffRequests(TOR_STATUSES.PENDING_APPROVAL, true, '');
      setData(response);
      setError(null);
    } catch (err) {
      console.error('Error loading time off requests:', err);
      setError('Failed to load time off requests. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    data.map((i) => {
      if (i.status === TOR_STATUSES.PENDING_APPROVAL) {
        setPendingApprovalStatus(true);
      }
    });
  }, [data])

  return (
    <>
      <SubHeader
        text="Time Off Requests"
        buttons={[{ icon: <Web sx={{ color: '#fff', fontSize: 30 }} />, onPress: () => navigate('/dashboard') }]}
      />

      <div className="wrap">
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        {loading && !data.length ? (
          <div className="h-100 d-flex justify-content-center p-5">
            <Spinner animation="border" />
          </div>
        ) : (
          <>
            <div className="button-grid">
              {menuOptions.slice(0, 3).map(option => (
                <div
                  key={option.id}
                  className="nav-tile"
                  style={{ color: option.text === 'Pending Approval' && pendingApprovalStatus ? '#da0f2edd' : '#797979' }}
                  onClick={() => navigate(option.to)}>
                  {option.text}
                </div>
              ))}
            </div>
            <div className="button-grid-bottom">
              {menuOptions.slice(3).map(option => (
                <div
                  key={option.id}
                  className="nav-tile"
                  style={{ color: '#797979' }}
                  onClick={() => navigate(option.to)}>
                  {option.text}
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      <Footer />
    </>
  );
};

export default TimeOffRequests;
